.app {
    min-height: 100vh;
    padding: 40px 20px;
    max-width: 600px;
    margin: 0 auto;
    display: flex;
    flex-direction: column;
    gap: 32px;
}